import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { Paginated } from "@hisense/shared";
import { apiFetch } from "@/lib/api";

export type ErpRow = Record<string, unknown>;

export function useErpList(resource: string, params: { q?: string; page?: number; pageSize?: number }) {
  return useQuery({
    queryKey: ["erp", resource, params],
    queryFn: ({ signal }) =>
      apiFetch<Paginated<ErpRow>>(`/${resource}`, {
        query: { q: params.q, page: params.page, pageSize: params.pageSize ?? 100 },
        signal,
      }),
    placeholderData: (previousData) => previousData,
  });
}
export function useErpCreate(resource: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: ErpRow) => apiFetch<{ data: ErpRow }>(`/${resource}`, { method: "POST", body }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["erp", resource] }),
  });
}
export function useErpUpdate(resource: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: { id: string; body: ErpRow }) => apiFetch<{ data: ErpRow }>(`/${resource}/${id}`, { method: "PUT", body }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["erp", resource] }),
  });
}
export function useErpDelete(resource: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => apiFetch<void>(`/${resource}/${id}`, { method: "DELETE" }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["erp", resource] }),
  });
}
